import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom';
import "./sidebar.css"
import { contextData } from '../../../context/ContextProvider';
import { AiOutlineAudit } from 'react-icons/ai';
import { GoTasklist } from "react-icons/go";
import { PiMicrosoftTeamsLogoThin } from "react-icons/pi";
import { Cuurent_EMAIL, Cuurent_gender, Cuurent_RBAC_roles, Cuurent_StaffId, Cuurent_USER_ROLES, Cuurent_UserIdProxy, Cuurent_USERNAME } from '../../CommonCase/CommonFunctions';



export const LiDiv = ({ active, func, location }) => {

  return (
    <li className={`sidebar-item ${active === 'tab3' ? 'active-tab' : ''}`} data-testid="LiDivsidebar" onClick={() => func('tab3')}>
      <div className="itemsIcon">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 35.74 31.285">
          <g id="Group_28474" data-name="Group 28474" transform="translate(-25.26 -307.555)">
            <g id="Ellipse_795" data-name="Ellipse 795" transform="translate(33 309)" fill="#fff" stroke="#00aff1" strokeWidth="1">
              <circle cx="14" cy="14" r="14" stroke="#00aff1" />
              <circle cx="14" cy="14" r="13.5" fill="none" />
            </g>
            <g id="Icon_feather-plus" data-name="Icon feather-plus" transform="translate(40 316)">
              <path id="Path_3716" data-name="Path 3716" d="M18,7.5v15" transform="translate(-10.5 -7.5)" fill="none" stroke="#00aff1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              <path id="Path_3717" data-name="Path 3717" d="M7.5,18h15" transform="translate(-7.5 -10.5)" fill="none" stroke="#00aff1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </g>
            <path id="Path_152510" data-name="Path 152510" d="M-954.6,997a17.336,17.336,0,0,0-8.64,15.08,17.948,17.948,0,0,0,8.64,15.32" transform="translate(989 -689)" fill="none" stroke="#00aff1" strokeWidth="1" />
          </g>
        </svg>
      </div>
      <span style={{ display: location === "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Control Reference</span>
    </li>
  );
};



export const AuditLink = ({ active, func1, func2, func3, func4, activeAuditSubTab, location }) => {
  return (
    <Link
      className={`sidebar-item ${active === 'tab4' ? 'active-tab' : ''}`}
      onMouseEnter={() => func1('tab4')}
      onMouseLeave={() => func2('tab4')}
      to='/main/audit/calendar'
      style={{ textDecoration: "none" }}
      data-testid='AuditLink'
    >
      <div className="itemsIcon">
        <AiOutlineAudit fill="#00ADEE" size="19px" />
      </div>
      <span style={{ display: location === "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Audit</span>
      {location !== "/main/meetings/calendar" &&
        <div id="tooltip-tab4" className="tooltip" style={{ top: "35%", left: "40%" }}>
          {/* Tooltip content */}
          <Link
            className={activeAuditSubTab === 3 ? "tooltip-link-active" : "tooltip-link-normal"}
            to='/main/audit/calendar'
            onClick={() => { func3('tab4'); func4(3); }}
          >
            Calendar
          </Link>
          <Link
            className={activeAuditSubTab === 1 ? "tooltip-link-active" : "tooltip-link-normal"}
            to='/main/audit/checklist' data-testid="activeAuditSubTabChecklist"
            onClick={() => { func3('tab4'); func4(1); }}
          >
            Checklist
          </Link>
          <Link
            className={activeAuditSubTab === 2 ? "tooltip-link-active" : "tooltip-link-normal"}
            to='/main/audit/observation'
            onClick={() => { func3('tab4'); func4(2); }}
          >
            Observations
          </Link>

          {/* Tooltip triangle */}
          <div className="tooltip-triangle"></div>
        </div>
      }
    </Link>
  );
};



const Sidebar = () => {
  const navigate = useNavigate();

  let rrbac = Cuurent_RBAC_roles();
  let userrole = Cuurent_USER_ROLES()





  // rbac roles
  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = userrole

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Dashboard");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, [])


  const AccRolesArr = userRole






  const { setActive, active, setActiveMeetingsSubTab, activeMeetingsSubTab, activeAuditSubTab, setActiveAuditSubTab, setViewPastMeeting, setActiveTBbutton } = useContext(contextData);
  const location = useLocation();
  const path = location?.pathname;


  function handleMouseEnter(tab) {
    const toolTipItem = document.getElementById(`tooltip-${tab}`);
    if (toolTipItem) {
      toolTipItem.style.display = 'block';
    }
  }

  function handleMouseLeave(tab) {
    const toolTipItem = document.getElementById(`tooltip-${tab}`);
    if (toolTipItem) {
      toolTipItem.style.display = 'none';
    }
  }

  useEffect(() => {
    if (path?.includes("control-reference")) {
      setActive("tab3")
    }
    else if (path?.includes("meetings")) {
      setActive("tab2")
    }
    else if (path?.includes("audit")) {
      setActive("tab4")
    }
    else if (path?.includes("taskboard")) {
      setActive("tab5")
    }
    else if (path?.includes("team-management")) {
      setActive("tab6")
    }
    else {
      setActive("tab1")
    }

    if (active == "tab1") {

    }


    // Meetings sub tabs
    if (path?.includes("my-meetings")) {
      setActiveMeetingsSubTab(1)
    }
    else if (path?.includes("meeting-summary")) {
      setActiveMeetingsSubTab(2)
    }
    else if (path?.includes("calendar")) {
      setActiveMeetingsSubTab(3)
    }


    if (path?.includes("checklist")) {
      setActiveAuditSubTab(1)
    }
    else if (path?.includes("observation")) {
      setActiveAuditSubTab(2)
    }
    else if (path?.includes("calendar")) {
      setActiveAuditSubTab(3)
    }
  }, [location?.pathname])

  const handleTabClick = (tab) => {
    setActive(tab);
    switch (tab) {
      case "tab1":
        navigate("/main");
        setActiveAuditSubTab(0)
        setActiveMeetingsSubTab(0)
        break;
      case "tab2":
        navigate("/main/meetings/my-meetings")
        setActiveAuditSubTab(0)
        setActiveMeetingsSubTab(1)
        setViewPastMeeting({ isView: false, meetingId: null })
        break;
      case "tab3":
        navigate("/main/control-reference");
        setActiveAuditSubTab(0)
        setActiveMeetingsSubTab(0)
        break;
      case "tab4":
        navigate("/main/audit/checklist")
        setActiveAuditSubTab(1)
        setActiveMeetingsSubTab(0)
        break;
      case "tab5":
        navigate("/main/taskboard");
        setActiveTBbutton(2)
        setActiveAuditSubTab(0)
        setActiveMeetingsSubTab(0)
        break;
      case "tab6":
        navigate("/main/team-management");
        setActiveAuditSubTab(0)
        setActiveMeetingsSubTab(0)
        break;
    }
  }
  const handleActiveTab = (tab) => {
    setActiveMeetingsSubTab(tab);
  }

  const handleAuditTab = (tab) => {
    setActiveAuditSubTab(tab);
  }


  return (
    <>
      <div className='sidebar-main' style={{ width: path == "/main/meetings/calendar" ? "4.5vw" : "18vw" }}>
        <ul className="sidebar-list" style={{ padding: path == "/main/meetings/calendar" && "5px 0px 20px 7px" }}>
          <li className={`sidebar-item ${active === 'tab1' ? 'active-tab' : ''}`} data-testid="Dashboard" onClick={() => handleTabClick('tab1')} >
            <div className="itemsIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 27.699 27.716">
                <path id="Icon_material-dashboard" data-name="Icon material-dashboard" d="M4.5,19.509h12V4.5H4.5Zm0,12.007h12V22.511H4.5Zm15,0h12V16.507h-12ZM19.5,4.5v9.005h12V4.5Z" transform="translate(-4.15 -4.15)" fill="none" stroke="#00adee" stroke-width="0.7" />
              </svg>
            </div>

            <span style={{ display: path == "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Dashboard</span>
          </li>
          <Link className={`sidebar-item ${active === 'tab2' ? 'active-tab' : ''}`}
            onMouseEnter={() => handleMouseEnter('tab2')}
            onMouseLeave={() => handleMouseLeave('tab2')}
            to='/main/meetings/my-meetings'
            style={{
              borderBottomRightRadius: path === "/main/meetings/calendar" ? "30px" : "",
              textDecoration: 'none'
            }}
            data-testid='mouseEvents'
          >
            <div className="itemsIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 33.462 31.212">
                <g id="Group_13766" data-name="Group 13766" transform="translate(-495 -427)">
                  <g id="Rectangle_6081" data-name="Rectangle 6081" transform="translate(495 427)" fill="none" stroke="#00aff1" stroke-width="1">
                    <rect width="33.462" height="24.092" rx="5" stroke="none" />
                    <rect x="0.5" y="0.5" width="32.462" height="23.092" rx="4.5" fill="none" />
                  </g>
                  <g id="Group_13765" data-name="Group 13765" transform="translate(504.82 450.745)">
                    <path id="Path_15904" data-name="Path 15904" d="M-343.16-123.366s4.339,3.494-.451,6.594" transform="translate(343.611 123.366)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-width="1" />
                    <path id="Path_15905" data-name="Path 15905" d="M-341.809-123.366s-4.339,3.494.451,6.594" transform="translate(355.164 123.366)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-width="1" />
                  </g>
                  <line id="Line_1517" data-name="Line 1517" x2="28.112" transform="translate(497.599 457.712)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-width="1" />
                  <path id="Path_15907" data-name="Path 15907" d="M0,0H33.093" transform="translate(495.096 439.227)" fill="none" stroke="#00aff1" stroke-width="1" />
                  <path id="Path_15908" data-name="Path 15908" d="M23.43,0H0" transform="translate(511.656 427) rotate(90)" fill="none" stroke="#00aff1" stroke-width="1" />
                  <g id="Icon_feather-user" data-name="Icon feather-user" transform="translate(499.236 430.956)">
                    <path id="Path_15909" data-name="Path 15909" d="M13.951,25.482v-.994A1.988,1.988,0,0,0,11.963,22.5H7.988A1.988,1.988,0,0,0,6,24.488v.994" transform="translate(-6 -17.307)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                    <path id="Path_15910" data-name="Path 15910" d="M15.976,6.488A1.988,1.988,0,1,1,13.988,4.5,1.988,1.988,0,0,1,15.976,6.488Z" transform="translate(-10.012 -4.5)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                  </g>
                  <g id="Icon_feather-user-2" data-name="Icon feather-user" transform="translate(515.739 430.956)">
                    <path id="Path_15909-2" data-name="Path 15909" d="M13.951,25.482v-.994A1.988,1.988,0,0,0,11.963,22.5H7.988A1.988,1.988,0,0,0,6,24.488v.994" transform="translate(-6 -17.307)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                    <path id="Path_15910-2" data-name="Path 15910" d="M15.976,6.488A1.988,1.988,0,1,1,13.988,4.5,1.988,1.988,0,0,1,15.976,6.488Z" transform="translate(-10.012 -4.5)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                  </g>
                  <g id="Icon_feather-user-3" data-name="Icon feather-user" transform="translate(515.739 442.448)">
                    <path id="Path_15909-3" data-name="Path 15909" d="M13.951,25.482v-.994A1.988,1.988,0,0,0,11.963,22.5H7.988A1.988,1.988,0,0,0,6,24.488v.994" transform="translate(-6 -17.307)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                    <path id="Path_15910-3" data-name="Path 15910" d="M15.976,6.488A1.988,1.988,0,1,1,13.988,4.5,1.988,1.988,0,0,1,15.976,6.488Z" transform="translate(-10.012 -4.5)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                  </g>
                  <g id="Icon_feather-user-4" data-name="Icon feather-user" transform="translate(499.236 442.255)">
                    <path id="Path_15909-4" data-name="Path 15909" d="M13.951,25.482v-.994A1.988,1.988,0,0,0,11.963,22.5H7.988A1.988,1.988,0,0,0,6,24.488v.994" transform="translate(-6 -17.307)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                    <path id="Path_15910-4" data-name="Path 15910" d="M15.976,6.488A1.988,1.988,0,1,1,13.988,4.5,1.988,1.988,0,0,1,15.976,6.488Z" transform="translate(-10.012 -4.5)" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                  </g>
                </g>
              </svg>
            </div>

            <span style={{ display: path == "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Meetings</span>
            {path !== "/main/meetings/calendar" &&
              <div id="tooltip-tab2" className="tooltip" style={{ top: "18%", left: "40%" }}>
                <Link className={activeMeetingsSubTab == 1 ? "tooltip-link-active" : "tooltip-link-normal"} data-testid="My-Meetings" to='/main/meetings/my-meetings' onClick={() => { handleTabClick('tab2'); handleActiveTab(1); }}>My Meetings</Link>
                {
                  // !AccRolesArr?.includes("QMS User")
                  (((AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee") || AccRolesArr?.includes("QMS Organizer")) && AccRolesArr?.includes("QMS User")) ||
                    ((AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee") || AccRolesArr?.includes("QMS Organizer"))))
                  &&
                  <Link className={activeMeetingsSubTab == 2 ? "tooltip-link-active" : "tooltip-link-normal"} to='/main/meetings/meeting-summary' onClick={() => { handleTabClick('tab2'); handleActiveTab(2); }}>Meetings Summary</Link>
                }
                <Link className="tooltip-link-normal" to='/main/meetings/calendar' data-testid='Calendar-Integration' onClick={() => { handleTabClick('tab2'); handleActiveTab(3); }}>Calendar Integration</Link>

                <div className="tooltip-wrapper">
                  <div className="tooltip-triangle"></div>
                </div>
              </div>
            }

          </Link>

          {AccRolesArr?.includes("QMS Organizer") ? (
            <LiDiv active={active} func={handleTabClick} location={path} />
          ) : (
            (((AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee")) && AccRolesArr?.includes("QMS User")) ||
              ((AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee")))) && ((
                <LiDiv active={active} func={handleTabClick} location={path} />
              ))
          )}



          {
            AccRolesArr?.includes("QMS Organizer") ?
              (
                <AuditLink
                  active={active}
                  func1={handleMouseEnter}
                  func2={handleMouseLeave}
                  activeAuditSubTab={activeAuditSubTab}
                  func3={handleTabClick}
                  func4={handleAuditTab}
                  location={path}
                />
              )
              :
              (((AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee")) && AccRolesArr?.includes("QMS User")) || (AccRolesArr?.includes("QMS Auditor") || AccRolesArr?.includes("QMS Auditee"))) &&
              (<AuditLink
                active={active}
                func1={handleMouseEnter}
                func2={handleMouseLeave}
                activeAuditSubTab={activeAuditSubTab}
                func3={handleTabClick}
                func4={handleAuditTab}
                location={path}
              />
              )
          }



          <li className={`sidebar-item ${active === 'tab5' ? 'active-tab' : ''}`} data-testid='Task-Board' onClick={() => handleTabClick('tab5')}>
            <div className="itemsIcon">
              <GoTasklist style={{ color: "#00ADEE" }} size={"19px"} />
            </div>
            <span style={{ display: path == "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Task Board</span>
          </li>

          {userRole?.includes("QMS Organizer") && <li className={`sidebar-item ${active === 'tab6' ? 'active-tab' : ''}`} onClick={() => handleTabClick('tab6')}>
            <div className="itemsIcon">
              <PiMicrosoftTeamsLogoThin style={{ color: "#00ADEE" }} size={"20px"} />
            </div>
            <span style={{ display: path == "/main/meetings/calendar" ? "none" : "" }} className="sidebar-link">Team Management</span>
          </li>
          }
        </ul>
        {/* </div> */}
        {/* {
          !(path.includes("/main/meetings/calendar") || path.includes("/main/meetings/my-meetings") || path.includes("/main/meetings/meeting-summary") || path == "/main") && <div className="colors">
            <h3 style={{ fontSize: "20px" }}>Tags</h3>
            <ul className='color-items'>

              <li className='color-item'>
                <div className="color hr-tag"></div>
                <span>Hr</span>
              </li>

              <li className='color-item'>
                <div className="color governance-tag"></div>
                <span>Governance</span>
              </li>

              <li className='color-item'>
                <div className="color it-tag"></div>
                <span>IT</span>
              </li>

              <li className='color-item'>
                <div className="color facillity-tag"></div>
                <span>Facillity</span>
              </li>

            </ul>
          </div>
        } */}

      </div >
    </>
  )
}

export default Sidebar